module.exports = "pegasus_template/assets/circleline-snapchat.png";